export default __webpack_public_path__ + "static/media/banner2.084e3cfc.jpg";